import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable} from 'rxjs';

@Injectable()
export class LicenseService {
    constructor(private http: HttpClient) {
    }
    peformActivation(resourceId: string, feature_type: string): Observable<any> {
        const URI = environment.rmpEndPointLicense.url + '/assign';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
        };
        const body = {
            resource_id : resourceId,
            feature_type : feature_type
        };
        return this.http.put<any>(URI, body, httpOptions);
    }

    revokeActivation(resourceId: string, feature_type: string): Observable<any> {
        const URI = environment.rmpEndPointLicense.url + '/remove';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
        };
        const body = {
            resource_id : resourceId,
            feature_type : feature_type
        };
        return this.http.post<any>(URI, body, httpOptions);
    }

    getSubscriptionDetails(feature_type: string): Observable<any> {
        const URI = environment.rmpEndPointSubscription.url + '/details';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'feature_type': feature_type
            }),
        };
        return this.http.get<any>(URI, httpOptions);
    }

}
